import script from "./CalendarView.vue?vue&type=script&setup=true&lang=js"
export * from "./CalendarView.vue?vue&type=script&setup=true&lang=js"

import "./CalendarView.vue?vue&type=style&index=0&id=82e8900e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82e8900e"]])

export default __exports__